import { useMemo } from 'react'
import { Asset, createAsset, SmpteTimestamp } from '@/organisms/AngelPlayer'
import { MediaSource } from '@/services/ProjectsService'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export interface useVideoAssetProps {
  projectSlug: string
  video?: VideoAsset
}

export interface VideoAsset {
  guid: string
  slug: string
  source: MediaSource
  title: string
  subtitle: string
  watchPosition?: WatchPosition
}

interface WatchPosition {
  position: number
}

interface AssetResponse {
  asset?: Asset
}

export const useVideoAsset = ({ projectSlug, video }: useVideoAssetProps): AssetResponse => {
  const { query } = useSafeRouter()

  const asset = useMemo(() => {
    if (!video) {
      return
    }

    const videoTitle = video.title
    const smpte = query.smpte as SmpteTimestamp
    const { guid, slug, source, subtitle } = video

    return createAsset({
      guid,
      projectSlug,
      slug,
      name: videoTitle,
      url: source.url,
      title: videoTitle,
      subtitle,
      position: smpte ?? video?.watchPosition?.position ?? 0,
      duration: source.duration,
      videoType: 'video',
    })
  }, [query?.smpte, projectSlug, video])

  return { asset }
}
